import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'conn-inline-datepicker',
  templateUrl: './inline-datepicker.component.html',
  styleUrls: ['./inline-datepicker.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InlineDatepickerComponent {
  @Input() maxDate: Date; // max date you can go to
  @Input() minDate: Date; // minimum date you can go do
  @Input() model: NgbDateStruct;
  @Output() modelChange: EventEmitter<NgbDateStruct>;

  constructor() {
    this.modelChange = new EventEmitter<NgbDateStruct>();
  }

  emitEvent(_event) {
    this.modelChange.emit(this.model);
  }
}
